import Cookies from "universal-cookie";

export const TOKEN_KEY = "guardian_auth_token";

const LOGIN_PATH = "/login";

// Ends the session and sends the browser to the login screen.
//
// Removing the cookie first is what keeps PrivateRoute from bouncing straight
// back here, and navigating instead of using the router forces a full reload: the
// apollo clients and the phoenix socket are created per session and would
// otherwise keep retrying with a token the server no longer accepts.
export const forceLogout = () => {
  new Cookies().remove(TOKEN_KEY, { path: "/" });

  if (window.location.pathname !== LOGIN_PATH) {
    window.location = LOGIN_PATH;
  }
};
